<template>
    <div class="ResidentialHomePage">
        <div>
            <b-row>
                <b-col align-self="center">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="paper">
                                <b-container fluid>
                                    <div v-if="User.PrivateProfile != null">
                                        <h1> Welcome {{User.PrivateProfile.FirstName}}</h1>
                                    </div>
                                </b-container>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="justify-content-md-center">
                <b-col align-self="center">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="paper">
                                <b-container fluid>
                                    <b-row>
                                        <b-col class="text-center">
                                            <h1>STAFF ON SHIFT</h1>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="12" md="6" lg="3" v-for="residence in Residences.ResidenceList">
                                            <h3>{{residence.Name}}</h3>
                                            <div v-for="(checkins,index) in residence.EmployeeCheckins">
                                                <p>
                                                    {{checkins.Employee.Person.FullName}}
                                                    <span v-if="EditMode && CheckPermission('CheckOutOthers')&& checkins.Employee.Id != User.PrivateProfile.EmployeeID">
                                                        <font-awesome-icon class="pointer" @click="ShowCheckOutModal(checkins.Employee.Id,residence.Id,checkins.Employee.Person.FullName,residence.Name)" :icon="['fa', 'door-open']" />
                                                    </span>
                                                    <br />({{formatLocalDateTime(checkins.CheckInDateTime)}})<br />
                                                    <span v-if="checkins.Employee.Person.PhoneNumbers.length > 0"> {{checkins.Employee.Person.PhoneNumbers[0].PhoneNumber.FormattedPhoneNumber}}</span>
                                                </p>
                                            </div>
                                            <div>
                                                <EmployeeCheckIn :ResidenceId="residence.Id" />
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <div>
                                        <EditMode Permission="CheckOutOthers" :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
                                    </div>
                                </b-container>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col align-self="center">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="paper">
                                <b-container fluid>
                                    <b-row>
                                        <!--<b-col>
                                    <h5>Important Phone Numbers</h5>
                                    <div>
                                        <p>
                                            Poison Control: (800)222-1222
                                        </p>
                                        <p>
                                            Riverside County Sheriff: (951)776-1099
                                        </p>
                                    </div>
                                </b-col>-->
                                        <b-col>
                                            <h5>Need Help?</h5>
                                            <div>
                                                <p>
                                                    Submit EHR Support Request: <a href="https://helpdesk.olivecrest.org" target="_blank">helpdesk.olivecrest.org</a>
                                                </p>
                                                <p>
                                                    Phone Support: (951)300-1240
                                                </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col align-self="center">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="paper">
                                <b-container fluid>
                                    <h3 class="text-center">Outlook Sync</h3>
                                    <GraphConnector />
                                </b-container>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-modal ref="toggle-modal" size="sm" :title="'Check Out ' + TargetEmployeeName + ' from ' + TargetResidenceName" hide-footer>
                <b-container>
                    <b-row>
                        <div class="form-group">
                            <label>Check In Date:</label>
                            <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="TargetDate"></flat-pickr>
                        </div>
                        <div class="form-group">
                            <label>Check Out Time:</label>
                            <flat-pickr class="form-control" :config="TimeInputConfigSchema" v-model="TargetTime"></flat-pickr>
                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="button" @click="SignOutOption">
                                CHECK Out
                            </b-button>
                        </div>
                    </b-row>
                </b-container>
            </b-modal>
        </div>
    </div>

</template>
<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import EmployeeCheckIn from '../Residential/Residences/EmployeeCheckIn.vue';
    import EditMode from '../Core/ItemEditors/EditMode.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExternalLinkSquareAlt);
    import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
    library.add(faDoorOpen);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import GraphConnector from '../Wraparound/Layouts/GraphConnector.vue';

    import { EventBus } from '../../services/event-bus.js';
    export default {
         created() {
            let vm = this;
            EventBus.$on('update-check-in-status', payload => {
                if (payload.ResidenceID == vm.ResidenceId) {
                    vm.CheckedIn = payload.Status;
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('update-check-in-status');
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_Portal.png",
                EditMode: false,
                Residences: [],
                User: {},
                TargetEmployeeID: "",
                TargetEmployeeName: "",
                TargetResidenceName: "",
                TargetResidenceID: "",
                TargetDate: "",
                TargetTime: "",
                 DateInputConfigSchema: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                TimeInputConfigSchema: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'h:i K',
                    onChange: function (selectedDates, dateStr, instance) {
                        if (dateStr === '') { instance.close(); }
                    }
                }
            };
        },
        methods: {
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatLocalDateTime(value, fmt = 'MMM Do h:mm A') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            SignOutOption() {
                console.log(this.TargetEmployeeID);
                this.$MasterAPI.ExecuteRequest("POST", "Residential/EmployeeCheckIn/CheckOutEmployee", { EmployeeID: this.TargetEmployeeID, ResidenceID: this.TargetResidenceID, TargetDateTime: this.combineTargetDateTimes() }, this.SignOutOptionSuccess, () => { }, true);
            },
            SignOutOptionSuccess(response) {
                EventBus.$emit('update-residence-list');
                EventBus.$emit('update-check-in-status', { Status: false, ResidenceID: this.ResidenceId });
                this.$refs["toggle-modal"].hide();
            },
            ShowCheckOutModal(EmployeeID,ResidenceID,EmployeeName,ResidenceName) {
                //moment().format("YYYY-MM-DD HH:mm");
                this.TargetDate = moment().format("YYYY-MM-DD");
                this.TargetTime = moment().format("HH:mm");
                this.ToggleModalTitle = this.CheckedIn ? "Check Out of House" : "Check In to House";
                this.TargetEmployeeID = EmployeeID;
                this.TargetResidenceID = ResidenceID;
                this.TargetEmployeeName = EmployeeName;
                this.TargetResidenceName = ResidenceName;
                this.$refs["toggle-modal"].show();
            },
            combineTargetDateTimes() {
                let output = this.TargetDate + " " + this.TargetTime;
                console.log(output);
                return output;
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            Cancel() {
                this.$refs["toggle-modal"].hide();
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        computed: {
        },
        mounted() {
            this.Residences = this.$store.state.Residences;
            this.User = this.$store.state.User;
        },
        components: {
            EmployeeCheckIn,
            flatPickr,
            EditMode,
            GraphConnector
        },
    }
</script>


<style scoped>
    /deep/ .EditDiv {
    position:relative !important; bottom:0px !important; z-index: 0 !important;
  }
</style>